import React, { useEffect, useState } from "react";

import SmartRtpEditFormLoader from "./components/SmartRtpEditFormLoader";
import {
  getGamesList,
  getPoolById,
  getPoolsList,
  savePool,
} from "../../../controllers/V1/smartRtp/smartRtpController";
import { round } from "../../../utils/bigMath";

const NUMBER_PROPS = { min: 0, step: 0.001, precision: 3 };

export default function SmartRtpPoolFormPage() {
  const [gameOptions, setGameOptions] = useState([]);

  useEffect(() => {
    const loadGames = async () => {
      const res = await getGamesList({ type: "", condition: {}, limit: 0, skip: 0, sort: { title: 1 } });
      if (res.status === true) {
        setGameOptions(
          (res.result || []).map((item) => ({ label: item.title, value: item._id }))
        );
      }
    };
    loadGames();
  }, []);

  const resolveByGameId = async (gameId) => {
    const res = await getPoolsList({
      type: "",
      condition: { game_id: gameId },
      limit: 1,
      skip: 0,
      sort: { createdAt: -1 },
    });
    if (res?.status === true && Array.isArray(res.result) && res.result.length > 0) {
      return res.result[0];
    }
    return null;
  };

  const fields = [
    { name: "pool_code", label: "Pool Code", rules: [{ required: true, message: "Pool code is required." }] },
    { name: "title", label: "Title" },
    {
      name: "game_id",
      label: "Game",
      type: "select",
      options: gameOptions,
      rules: [{ required: true, message: "Game is required." }],
    },
    {
      name: "initial_balance",
      label: "Initial Balance",
      type: "number",
      props: NUMBER_PROPS,
      rules: [{ required: true, message: "Initial balance is required." }],
    },
    {
      name: "current_balance",
      label: "Current Balance",
      type: "number",
      props: NUMBER_PROPS,
    },
    {
      name: "min_reserve",
      label: "Minimum Reserve",
      type: "number",
      props: NUMBER_PROPS,
    },
    {
      name: "target_rtp",
      label: "Target RTP %",
      type: "number",
      props: { min: 0, max: 100, step: 0.001, precision: 3 },
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { label: "Active", value: "Active" },
        { label: "Frozen", value: "Frozen" },
        { label: "Closed", value: "Closed" },
      ],
    },
  ];

  return (
    <SmartRtpEditFormLoader
      titlePrefix="Smart RTP Pool"
      backTo="/smart-rtp/games"
      fields={fields}
      fetchById={getPoolById}
      resolveByGameId={resolveByGameId}
      defaultsForGameId={(gameId) => ({
        game_id: gameId,
        status: "Active",
      })}
      mapInitial={(row) => ({
        ...row,
        initial_balance:
          row?.initial_balance != null ? round(row.initial_balance, 3) : undefined,
        current_balance:
          row?.current_balance != null ? round(row.current_balance, 3) : undefined,
        min_reserve: row?.min_reserve != null ? round(row.min_reserve, 3) : undefined,
        target_rtp: row?.target_rtp != null ? round(row.target_rtp, 3) : undefined,
      })}
      onSave={(values, editId) =>
        savePool({
          ...values,
          initial_balance:
            values.initial_balance != null ? round(values.initial_balance, 3) : values.initial_balance,
          current_balance:
            values.current_balance != null ? round(values.current_balance, 3) : values.current_balance,
          min_reserve:
            values.min_reserve != null ? round(values.min_reserve, 3) : values.min_reserve,
          target_rtp:
            values.target_rtp != null ? round(values.target_rtp, 3) : values.target_rtp,
          ...(editId ? { editId } : {}),
        })
      }
      defaultValues={{
        status: "Active",
      }}
    />
  );
}
